import React from 'react';

const LoadingSpinner = ({ 
  size = 'md', 
  message = 'Yükleniyor...',
  showMessage = true,
  fullScreen = false
}) => {
  const sizeClasses = {
    sm: 'h-6 w-6 border-2',
    md: 'h-12 w-12 border-2',
    lg: 'h-16 w-16 border-3',
    xl: 'h-24 w-24 border-4'
  };

  const spinnerClass = sizeClasses?.[size] || sizeClasses?.md;

  const content = (
    <div className="text-center">
      <div className={`animate-spin rounded-full ${spinnerClass} border-b-primary mx-auto mb-4`}></div>
      {showMessage && (
        <p className="text-muted-foreground">{message}</p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        {content}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-[400px]">
      {content}
    </div>
  );
};

export default LoadingSpinner;